import { Launch } from "@mui/icons-material";
import {
  CircularProgress,
  IconButton,
  List,
  ListItem,
  ListSubheader,
  Tooltip,
} from "@mui/material";
import React, { useContext, useState } from "react";

import DataContext from "../../../../context/DataContext";
import { useHistoryNavigate } from "../../../../hooks/useHistoryNavigate";
import { case_detail } from "../../../api/endpoints/case";
import ApiRequestErrorHandler from "../../ApiRequestErrorHandler";

export default function MultiUserDisplay({ logId, users }) {
  const { accessToken } = useContext(DataContext);
  const [isLoading, setIsLoading] = useState(false);
  const { historyNavigate } = useHistoryNavigate();

  const navigateToDetail = (clientId) => {
    case_detail
      .getCaseByClientId(clientId, accessToken)
      .then((response) => {
        historyNavigate("client-detail", response.results[0].pk);
        setIsLoading(false);
        return response;
      })
      .catch((error) => {
        setIsLoading(false);
        return ApiRequestErrorHandler(error.response);
      });
  };

  return (
    <List
      id="Item-Multi"
      data-testid="Item-Multi"
      style={{
        minHeight: "100%",
        bgcolor: "background.paper",
        overflowY: "auto",
        margin: "1rem",
        padding: "0rem 1rem 1rem 1rem",
        border: "1px solid #ccc",
        display: users.length > 1 ? "block" : "none",
      }}
      dense={true}
    >
      {!users ? (
        "Unknown"
      ) : users.length > 1 ? (
        <div id={"list_" + logId} key={"list_" + logId}>
          <ListSubheader sx={{ backgroundColor: "#fff", borderBottom: "1px solid #ccc" }}>
            <p style={{ lineHeight: "1.5rem", paddingTop: "0.5rem" }}>
              *Users sharing the same phone number as: &nbsp;
              <br />
              <span className="text-gray-800">{users[0].user_name}</span>
            </p>
          </ListSubheader>
          {users.map((user, idx) => {
            return (
              <ListItem id={"listItem_" + logId + "_" + idx} key={"key_" + logId + "_" + idx}>
                {user.user_name && user.user !== users[0].user ? (
                  <div
                    className="w-full"
                    style={{
                      borderBottom: "1px solid #eee",
                      borderTop: "none",
                    }}
                  >
                    {user.user_name}
                    {user?.is_client &&
                      (!isLoading ? (
                        <Tooltip title="Open Case Details">
                          <IconButton
                            onClick={() => navigateToDetail(user?.user)}
                            className="ml-1 justify-start text-purple-600 hover:bg-purple-600 hover:text-white"
                          >
                            <Launch />
                          </IconButton>
                        </Tooltip>
                      ) : (
                        <CircularProgress color="secondary" />
                      ))}
                  </div>
                ) : (
                  ""
                )}
              </ListItem>
            );
          })}
        </div>
      ) : (
        ""
      )}
    </List>
  );
}
